import { CheckCircle } from "lucide-react";

export const SocialProof = ({ showSocialProof, socialProof }) => {
  if (!showSocialProof || !socialProof) return null;
  
  return (
    <div className="fixed bottom-4 left-4 z-50 animate-slide-in-left">
      <div className="bg-white rounded-xl shadow-2xl p-4 max-w-xs border-l-4 border-[#009C3B]">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#009C3B] rounded-full flex items-center justify-center">
            <CheckCircle className="w-5 h-5 text-white" />
          </div>
          <div>
            <p className="text-sm font-bold text-[#002776]">{socialProof.nome} de {socialProof.cidade}</p>
            <p className="text-xs text-gray-500">garantiu o voucher há {socialProof.minutos} min</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialProof;
